import { render, staticRenderFns } from "./AfterSaleQuizReport.vue?vue&type=template&id=05fc316b"
import script from "./AfterSaleQuizReport.vue?vue&type=script&lang=js"
export * from "./AfterSaleQuizReport.vue?vue&type=script&lang=js"
import style0 from "./AfterSaleQuizReport.vue?vue&type=style&index=0&id=05fc316b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports